import { useState } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Button,
  Snackbar, Alert, CircularProgress, Backdrop, Box
} from '@material-ui/core';
import React from 'react';
import ArrayFields from '../main/book/ArrayFields';
import SuccessDialog from './create_form/SuccessDialog';
import { createBook } from '../../services/api';
import TextField from '../general/TextField';

const CreateForm = ({ userStore }) => {
  const initData = {
    title: '',
    authors: []
  };

  const [formData, setFormData] = useState({ ...initData });
  const [successDialogOpened, setSuccessDialogOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [book, setBook] = useState(null);
  const [snack, setSnack] = useState({
    message: '',
    severity: 'success',
    open: false
  });

  const [errors, setErrors] = useState({
    hasErrors: false,
    title: false,
    authors: false
  });

  const clearForm = () => {
    setFormData({ ...initData });
  };

  const handleChangeFormValue = (field, value) => {
    setFormData({
      ...formData,
      [field]: value
    });
  };

  const handleSnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnack({
      ...snack,
      open: false
    });
  };

  const onFormSubmit = async () => {
    if (loading) {
      return;
    }

    const data = {
      ...formData,
      authors: formData.authors.map(authorName => ({ author: { name: authorName } }))
    };

    setErrors({
      title: data.title === '',
      authors: formData.authors.length <= 0,
      hasErrors: data.title === '' || formData.authors.length <= 0
    });

    if (errors.hasErrors) {
      return;
    }

    setLoading(true);

    try {
      const response = await createBook(userStore.token, data);
      setBook(response.data.data);
      setSuccessDialogOpened(true);
      setLoading(false);
    } catch (e) {
      if (e.response.data?.error?.fields) {
        const errors = e.response.data.error.fields;
        setSnack({
          message: Object.keys(errors).map(key => errors[key][0]).join(' - '),
          severity: 'error',
          open: true
        });
      }
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardContent>
        <SuccessDialog opened={successDialogOpened} book={book} handleClose={() => {
          setSuccessDialogOpened(false);
          clearForm();
        }} />
        <Backdrop open={loading}><CircularProgress /></Backdrop>
        <Snackbar open={snack.open} autoHideDuration={5000} onClose={handleSnackClose}
                  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={() => handleSnackClose(null, null)} severity={snack.severity}>
            {snack.message}
          </Alert>
        </Snackbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField error={errors['title']} label='Título'
                       handleChange={value => handleChangeFormValue('title', value)} />
          </Grid>
          <Grid item xs={12}>
            <ArrayFields title='Autor' error={errors['authors']} data={[...formData.authors]} onChange={(newArray) => {
              setFormData({
                ...formData,
                authors: newArray
              });
            }} />
          </Grid>
          <Grid item xs={12}>
            <Button size='large' variant='contained' onClick={() => onFormSubmit()}>Salvar</Button>
          </Grid>
        </Grid>

      </CardContent>
    </Card>
  );
};

export default CreateForm;
